export function getSkipIntroStartTime(
  getMetaData
) {
  const metaData = getMetaData()
  const cuePoints = metaData.cuePoints
  const skipIntroStart = cuePoints.find(cp => cp.name === 'skip_intro_start')

  return skipIntroStart?.time
}
